<template>
    <div id="collect_data">
        <div id="test" class="d-flex flex-column align-items-center mx-auto pb-lg-5">

            <div class="px-4 px-md-5">
                <img src="../assets/img/Group60.png" alt="" class="img-fluid">
            </div>

            <form id="form" class="d-flex flex-column w-100">
                <div id="inputs" class="d-flex flex-column mx-auto mt-5 mb-3 w-100">

                    <h5 class="mt-sm-5 mt-md-3 px-4 pt-sm-5 mb-1">
                        Completează formularul pentru a participa
                    </h5>

                    <div class="d-flex flex-column w-100 mb-0 px-4">
                        <input type="text" v-model="form.nume" placeholder="Nume*"
                               id="last_name" name="last_name" data-vv-as=" " v-validate="'required'">
                        <span class="error">{{ errors.first('last_name') }}</span>
                    </div>

                    <div class="d-flex flex-column w-100 mb-0 px-4">
                        <input type="text" v-model="form.prenume" placeholder="Prenume*"
                               id="first_name" name="first_name" data-vv-as=" " v-validate="'required'">
                        <span class="error">{{ errors.first('first_name') }}</span>
                    </div>

                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="d-flex flex-column w-100 mb-0 px-4 pr-md-2">
                            <input type="text" v-model="form.telefon"
                                   placeholder="Telefon*"
                                   v-validate="'required'" data-vv-as=" " id="phone_no" name="phone_no">
                            <span class="error">{{ errors.first('phone_no') }}</span>
                        </div>

                        <div class="d-flex flex-column w-100 mb-0 px-4 pl-md-2">
                            <input type="text" v-model="form.cod" id="code" name="code"
                                   v-validate="'required|max:8'" data-vv-as=" " placeholder="Cod de participare*">
                            <span class="error">{{ errors.first('code') }}</span>
                        </div>

                    </div>

                    <div class="d-flex flex-column w-100 mb-0 px-4">
                        <input type="text" v-model="form.email" placeholder="Email"
                               v-validate="'email'" data-vv-as=" " id="email" name="email">
                        <span class="error">{{ errors.first('email') }}</span>
                    </div>

                    <div class="d-flex flex-column flex-md-row justify-content-between w-100">
                        <div class="d-flex flex-column w-100 mb-0 px-4 pr-md-2">
                            <input type="text" v-model="captcha"
                                   placeholder="Cod Captcha*"
                                   v-validate="'required'" data-vv-as=" " id="captcha" name="captcha">
                            <span class="error">{{ errors.first('captcha') }}</span>
                        </div>

                        <div class="d-flex flex-column w-100 mb-0 px-4 pl-md-2">
                            <div>
                                <div id="captcha_code"></div>
                            </div>
                        </div>
                    </div>

                    <span class="mx-4">* Aceste câmpuri sunt obligatorii</span>

                </div>

                <div id="checkbox" class="d-flex flex-column mx-auto mb-3 w-100">

                    <div class="d-flex flex-column px-4 mb-0">
                        <label class="checkbox-container" for="checkbox1">Am luat la cunoștință și sunt de acord cu
                            <a href="./Regulament.pdf" target="_blank">regulamentul campaniei</a>
                            <input type="checkbox" id="checkbox1" name="checkbox1" v-validate="'required'"
                                   data-vv-as=" ">
                            <span class="checkmark"></span>
                        </label>
                        <span class="error">{{ errors.first('checkbox1') }}</span>
                    </div>

                    <div class="d-flex flex-column px-4 mb-0">
                        <label class="checkbox-container" for="checkbox2">Sunt de acord cu prelucrarea datelor personale
                            colectate și pentru
                            introducerea acestora în baza de date a Organizatorului în scopuri de marketing direct
                            <input type="checkbox" id="checkbox2" name="checkbox2" v-validate="'required'"
                                   data-vv-as=" ">
                            <span class="checkmark"></span>
                        </label>
                        <span class="error">{{ errors.first('checkbox2') }}</span>
                    </div>

                    <div class="d-flex flex-column px-4 mb-0">
                        <label class="checkbox-container" for="checkbox3">Accept
                            <a href="https://racorestebarbatul.ro/termeni-si-conditii/" target="_blank">politica
                                GDPR</a>
                            <input type="checkbox" id="checkbox3" name="checkbox3" v-validate="'required'"
                                   data-vv-as=" ">
                            <span class="checkmark"></span>
                        </label>
                        <span class="error">{{ errors.first('checkbox3') }}</span>
                    </div>

                </div>

                <div v-show="error" class="d-flex flex-column mx-auto">
                    <span class="d-flex mx-auto error api-error mb-3 w-45 text-center pb-2 px-5"
                          v-text="errorMessage"
                    ></span>
                </div>

                <div class="mb-2 mb-md-5 mx-auto" v-if="!loading">
                    <button @click.prevent="onSave">
                        Trimite
                    </button>
                </div>

                <div class="mb-2 mb-md-5 mx-auto" v-if="loading" style="height: 53px">
                    <div class="hollow-dots-spinner">
                        <div class="dot"></div>
                        <div class="dot"></div>
                        <div class="dot"></div>
                    </div>
                </div>
            </form>

            <div v-if="success">
                <SuccessDialog
                        :key="'dialog'"
                        v-on:refresh="onRefresh"></SuccessDialog>
            </div>

        </div>
    </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    const axios = require('axios');

    import SuccessDialog from "@/components/SuccessDialog";

    export default {
        name: "Form",
        components: {
            SuccessDialog,
        },
        data() {
            return {
                form: {
                    idnet: '',
                    nume: '',
                    prenume: '',
                    telefon: '',
                    cod: '',
                    email: '',
                },
                captcha: '',
                captchaGeneratedCode: '',

                apiUrl: '',

                success: false,
                error: false,
                errorMessage: null,
                loading: false,
            }
        },
        watch: {
            'form': {
                deep: true,
                immediate: true,
                handler() {
                    this.error = false;
                    this.errorMessage = null;
                }
            }
        },
        mounted() {
            this.apiUrl = 'https://racorestebarbatul.ro/campanie/api/api.php';
            this.generateCaptcha();
        },
        methods: {
            serialize(obj) {
                var str = [];
                for (var p in obj)
                    //if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                //}
                return str.join("&");
            },
            onRefresh() {
                let self = this;
                self.success = false;
                self.form = {
                    idnet: '',
                    nume: '',
                    prenume: '',
                    telefon: '',
                    cod: '',
                    email: '',
                };
                self.captcha = '';
                self.generateCaptcha();
                setTimeout(function () {
                    self.errors.clear();
                }, 100);
            },
            generateCaptcha() {
                let self = this;
                document.getElementById('captcha_code').innerHTML = "";
                var charsArray = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
                var lengthOtp = 6;
                var captcha = [];
                for (var i = 0; i < lengthOtp; i++) {
                    //below code will not allow Repetition of Characters
                    var index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
                    if (captcha.indexOf(charsArray[index]) == -1)
                        captcha.push(charsArray[index]);
                    else i--;
                }
                var canv = document.createElement("canvas");
                canv.id = "captcha_canvas";
                canv.width = 150;
                canv.height = 40;
                canv.style.paddingLeft = "30px";
                canv.style.transform = "scaleX(1.5)"
                var ctx = canv.getContext("2d");

                ctx.font = 'bold 26px arial,sans-serif';
                ctx.fillStyle = 'black';
                ctx.setTransform(1, -0.1, 0, 1, 0, 0);
                ctx.fillText(captcha.join(""), 10, 35);
                ctx.setTransform(1, 0, 0, 1, 0, 0);

                //storing captcha so that can validate you can save it somewhere else according to your specific requirements
                self.captchaGeneratedCode = captcha.join("");
                document.getElementById("captcha_code").appendChild(canv); // adds the canvas to the body element
            },
            onSave() {
                let self = this;
                self.loading = true;

                // setTimeout(function () {
                //     self.success = true;
                //     self.loading = false;
                //     window.$('#success_dialog').modal('show');
                // }, 100);

                if (self.captcha == self.captchaGeneratedCode) {
                    this.$validator.validate().then(valid => {
                        if (valid) {
                            let idNet = Date.now() + Math.random();
                            self.form.idnet = idNet;
                            console.log('form', self.form);

                            axios.post(self.apiUrl + '?' + this.serialize(self.form), self.form)
                                .then(function (response) {
                                    console.log('response', response)

                                    if (response.data.response.status == 1) {

                                        self.success = true;
                                        self.$store.commit('setCode', self.form.cod)
                                        self.$store.commit('setResponse', response.data.response)

                                        setTimeout(function () {
                                            self.$forceUpdate();
                                            self.loading = false;
                                            window.$('#success_dialog').modal('show');
                                        }, 100);

                                    } else {
                                        self.loading = false;
                                        self.error = true;
                                        let errorResponse = response.data.response;

                                        if (errorResponse.messageStatus == 'inainte_campanie') {
                                            self.errorMessage = 'Campania SKOL RĂCOREȘTE BĂRBATUL ȘI PREMIAZĂ! începe pe 01.06.2021. Păstrează capacul/cheiță și trimite codul după această dată.'
                                        } else if (errorResponse.messageStatus == 'dupa_campanie') {
                                            self.errorMessage = 'Campania SKOL RĂCOREȘTE BĂRBATUL ȘI PREMIAZĂ! s-a terminat. Te așteptăm la viitoarele campanii SKOL!'
                                        } else if (errorResponse.messageStatus == 'dubla') {
                                            self.errorMessage = 'Codul ' + self.form.cod + ' a mai fost înregistrat în campanie. Cumpără un nou produs participant SKOL și înscrie un nou cod pentru a acumula noi șanse la premii! Poți câștigă prin tragere la sorți unul dintre premiile puse în joc! Detalii în Regulamentul Oficial'
                                        } else if (errorResponse.messageStatus == 'incorect') {
                                            self.errorMessage = 'Codul este incorect. Înscrie codul promoțional de 8 caractere alfanumerice, fără semne de punctuație, spații sau alte caractere. Cu SKOL poți câștiga prin tragere la sorți unul dintre premiile puse în joc! Detalii în Regulamentul Oficial.'
                                        } else if (errorResponse.messageStatus == 'blocat_corecte' && errorResponse.lastDay == false) {
                                            self.errorMessage = 'Ai atins deja limita maximă de 10 coduri valide pe zi permise, conform Regulamentului Oficial. Acest cod nu va fi înregistrat în campanie. Îl poți înregistra mâine alături de noi coduri. Poți câștigă prin tragere la sorți unul dintre premiile puse în joc! Succes!'
                                        } else if (errorResponse.messageStatus == 'blocat_corecte' && errorResponse.lastDay == true) {
                                            self.errorMessage = 'Ai atins deja limita maximă de 10 coduri pe zi, conform Regulamentului Oficial. Acest cod nu va fi înregistrat. Azi este ultima zi de promoție! Te așteptăm la viitoarele campanii SKOL!'
                                        } else {
                                            self.errorMessage = response.data.response.message;
                                        }

                                    }

                                })
                                .catch(function (error) {
                                    console.log('error', error);
                                    self.loading = false;
                                    self.error = true;
                                    self.errorMessage = error.response.data.error.message;
                                });
                        } else {
                            self.loading = false;
                        }
                    });
                } else {
                    self.loading = false;
                    if (self.captcha != self.captchaGeneratedCode && self.captcha != '') {
                        self.errors.add({
                            field: 'captcha',
                            msg: 'Cod greșit'
                        })
                        self.generateCaptcha();
                    }
                    if (self.captcha == '') {
                        self.errors.add({
                            field: 'captcha',
                            msg: 'Câmpul este obligatoriu'
                        })
                    }
                }
            },

        }
    }
</script>

<style scoped>

    canvas {
        /*prevent interaction with the canvas*/
        pointer-events: none;
    }

    @font-face {
        font-family: 'HelveticaNeueCondensedBold';
        src: url('../assets/fonts/HelveticaNeue-CondensedBold.woff2') format('woff2'),
        url('../assets/fonts/HelveticaNeue-CondensedBold.woff') format('woff');
        font-weight: 900;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'HelveticaNeueBold';
        src: url('../assets/fonts/HelveticaNeue-Bold.woff2') format('woff2'),
        url('../assets/fonts/HelveticaNeue-Bold.woff') format('woff');
        font-weight: 800;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'HelveticaNeueMedium';
        src: url('../assets/fonts/HelveticaNeue.woff2') format('woff2'),
        url('../assets/fonts/HelveticaNeue.woff') format('woff');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: 'HelveticaNeueLight';
        src: url('../assets/fonts/HelveticaNeue-Light.woff2') format('woff2'),
        url('../assets/fonts/HelveticaNeue-Light.woff') format('woff');
        font-weight: 100;
        font-style: normal;
        font-display: swap;
    }

    #collect_data #inputs, #collect_data #checkbox {
        max-width: 624px;
    }

    #collect_data #inputs input {
        background: #FFE491;
        border: 0;
        outline: 0;
        height: 50px;
        padding-left: 18px;
        color: #1d561b;
        font-family: 'HelveticaNeueBold';
    }

    ::placeholder {
        color: #205D3B;
    }

    #collect_data #form span {
        font-size: 12px;
        color: #205D3B;
        font-family: 'HelveticaNeueBold';
    }

    #collect_data #form span.error {
        font-size: 12px;
        color: #bd050e;
        font-family: 'HelveticaNeueMedium';
        display: block !important;
        min-height: 18px;
    }

    #collect_data button {
        color: #FCCA33;
        background-color: #205D3B;
        outline: 0;
        border: 0;
        padding: 10px 40px;
        font-size: 22px;
        text-transform: uppercase;
        border-radius: 30px;
        transition: all 0.2s linear;
        font-family: 'HelveticaNeueBold';
    }

    #collect_data button:hover, #collect_data button:active {
        color: white;
        transition: all 0.2s linear;
    }

    #collect_data #form {
        background-image: url("../assets/img/Ellipse1.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
    }

    @media (max-width: 1150px) {
        #collect_data #form {
            background-size: cover;
        }
    }

    @media (min-width: 600px) {
        #collect_data img {
            max-width: 478px;
        }
    }

    #collect_data #form h5 {
        color: #1d561b;
        font-family: 'HelveticaNeueBold';
    }

    @media (min-width: 390px) and (max-width: 575px) {
        #collect_data #form h5 {
            margin-top: 2.5rem;
        }
    }

    a {
        color: #1d561b;
        text-decoration: underline;
    }

    /*checkbox*/
    .checkbox-container {
        display: block;
        position: relative;
        padding-left: 26px;
        margin-bottom: 0;
        cursor: pointer;
        font-size: 12px;
        color: #205D3B;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        font-family: 'HelveticaNeueBold';
    }

    .checkbox-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 20px;
        width: 20px;
        background-color: transparent;
        border: 2px solid #1D561B;
        transition: all 0.2s linear;
    }

    .checkbox-container:hover input ~ .checkmark {
        background-color: rgba(29, 86, 27, 0.5);
        transition: all 0.2s linear;
    }

    .checkbox-container input:checked ~ .checkmark {
        background-color: #1D561B;
        transition: all 0.2s linear;
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .checkbox-container input:checked ~ .checkmark:after {
        display: block;
    }


    /*loading*/
    .hollow-dots-spinner, .hollow-dots-spinner * {
        box-sizing: border-box;
    }

    .hollow-dots-spinner {
        height: 15px;
        width: calc(30px * 3);
    }

    .hollow-dots-spinner .dot {
        width: 15px;
        height: 15px;
        margin: 0 calc(15px / 2);
        border: calc(15px / 5) solid #1D561B;
        border-radius: 50%;
        float: left;
        transform: scale(0);
        animation: hollow-dots-spinner-animation 1000ms ease infinite 0ms;
    }

    .hollow-dots-spinner .dot:nth-child(1) {
        animation-delay: calc(300ms * 1);
    }

    .hollow-dots-spinner .dot:nth-child(2) {
        animation-delay: calc(300ms * 2);
    }

    .hollow-dots-spinner .dot:nth-child(3) {
        animation-delay: calc(300ms * 3);

    }

    @keyframes hollow-dots-spinner-animation {
        50% {
            transform: scale(1);
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    }

    .w-45 {
        width: 45%;
    }

    @media (max-width: 991px) {
        .w-45 {
            width: 85%;
        }
    }
</style>
